import { withNamespaces } from "react-i18next";
import { Col, Container, Row } from "reactstrap";
import Navigator from "src/components/Navigator";
import CreateBatch from "./components/create-batch";

const EudrDueDiligenceDeclare = ({ t }) => {
    return (
        <div className='page-content thirdparty-questionnaire'>
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator
                            backButtonOptions={(props) => ({
                                ...props,
                                enable: true,
                            })}
                            breadCrumbs={[
                                {
                                    title: 'SIP',
                                    link: '/third-party/3rd-party/home'
                                },
                                {
                                    title: 'My reports',
                                    link: '/third-party/3rd-party/reports'
                                },
                                {
                                    title: 'EUDR Due Diligence',
                                    link: '/third-party/3rd-party/eudr-due-diligence'
                                },
                                {
                                    title: 'Report',
                                    link: '#'
                                }
                            ]}
                            pageTitle="EUDR Due Diligence Report"
                        />
                    </Col>
                </Row>

                <Row>
                    <Col sm='12'>
                        <CreateBatch />
                    </Col>
                </Row>
            </Container>
        </div>
    )
};

export default withNamespaces()(
    EudrDueDiligenceDeclare
);